module.exports = __webpack_public_path__ + "img/enero2026.763fdada.png";